import { authorizationHeader } from "../../util/fetchUtil";
import { responseBody } from "../../util/fetchUtil";
import { TokenManager } from "../../util/TokenManager";

// const host = process.env.REACT_APP_API_HOST;
// const host = "https://portolaprod.azurewebsites.net/";
const host = "https://portolaprod.azurewebsites.net/";


export const loadBootstrapData = async (limit, offset) => {
  try {
    const url = `${host}/api/bootstrap/`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: authorizationHeader(TokenManager.getToken()),
      },
    });
    const responseAsJSON = await responseBody(response);
    return responseAsJSON;
  } catch (err) {
    throw err;
  }
};
